import React, { useEffect } from "react";
import { MagnifyingGlassIcon, LinkIcon } from "@heroicons/react/24/outline";
import { useSearch } from "../util/SearchContext";

export default function SearchBarLarge({ placeholder, isSearching }) {
  const { searchQuery, setSearchQuery, handleSearch } = useSearch();

  useEffect(() => {
    setSearchQuery(searchQuery || "");
  }, [searchQuery, setSearchQuery]);

  const handleInput = (e) => setSearchQuery(e.target.value);
  const handleKeyDown = (e) => { if (e.key === "Enter") handleSearch(searchQuery); };

  return (
    <div className="w-full max-w-2xl mt-4">
      <div className="flex items-center bg-white border border-gray-300 rounded-full shadow-md p-1.5 sm:p-2">
        <input
          type="text"
          value={searchQuery}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="flex-1 bg-transparent outline-none px-3 text-gray-800 placeholder-gray-500 text-sm sm:text-base truncate"
        />
        <button
          onClick={() => handleSearch(searchQuery)}
          className={`text-white p-2 sm:p-3 rounded-full transition duration-300 ${isSearching ? 'bg-green-700' : 'bg-green-600 hover:bg-green-700'}`}
        >
          {searchQuery.startsWith("http") ? <LinkIcon className="w-4 h-4 sm:w-5 sm:h-5" /> : <MagnifyingGlassIcon className="w-4 h-4 sm:w-5 sm:h-5" />}
        </button>
      </div>
    </div>
  );
}
